'use client';

import { AudioPlayer } from '@/components/audio-player';
import { useApiV1Ctx } from '@/components/providers/v1-api';
import { Skeleton } from '@/components/ui/skeleton';

interface CallAudioProps {
  ref?: React.RefObject<HTMLAudioElement | null>;
  callId: string;
  callRecordingId: string;
}

export function CallAudio({ ref, callId, callRecordingId }: CallAudioProps) {
  const { api } = useApiV1Ctx();

  const { data: src, isLoading } =
    api.externalCalls.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQuery(
      {
        path: { external_call_id: callId, external_call_recording_id: callRecordingId },
      }
    );

  if (isLoading) {
    return <Skeleton className='h-12 w-full rounded-full' />;
  }

  if (!src) {
    return (
      <div className='flex h-12 w-full items-center justify-center rounded-full bg-muted/50 text-sm text-muted-foreground'>
        No audio available
      </div>
    );
  }

  return <AudioPlayer ref={ref} url={src} className='h-12 w-full' />;
}
